const CURRENT_HOTEL_GRAPH_COLOR_RGB = '32,129,172';
export default CURRENT_HOTEL_GRAPH_COLOR_RGB;
